import { useSelector } from "react-redux";
import "./CurrencyInputField.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CurrencyInputField = ({
  placeholder = "",
  name = "",
  isRequired,
  label = null,
  isDisabled = false,
  errorMessage = undefined,
  onChange = () => {},
  value = "",
  register = () => {},
  onKeyUp = () => {},
}) => {
  const { currency_code } = useSelector(
    (state) => state.profileDetailsReducer.businessDetails,
  );

  return (
    <div className="currency-input-field">
      {label !== null && (
        <label htmlFor={name}>
          {isRequired && <span className="text-danger">*</span>}
          <span>{label}</span>
        </label>
      )}
      <div
        className={`currency-input-field__input-section ${
          errorMessage !== undefined && "error-border"
        }`}
      >
        <input
          type="text"
          name={name}
          id={name}
          placeholder={placeholder}
          disabled={isDisabled}
          defaultChecked={value}
          {...register(name, { required: isRequired })}
          onChange={onChange}
          onKeyUp={onKeyUp}
        />
        <span>{currency_code}</span>
      </div>
      <p
        className={`error-message text-danger ${
          errorMessage !== undefined ? "show" : ""
        }`}
      >
        <FontAwesomeIcon
          icon={["fas", "exclamation-circle"]}
          className="mr-2"
          style={{ fontSize: "13px" }}
        />
        {errorMessage !== undefined && <span>{errorMessage.message}</span>}
      </p>
    </div>
  );
};

export default CurrencyInputField;
